<!-- begin:: Header Mobile -->
<div id="kt_header_mobile" class="kt-header-mobile kt-header-mobile--fixed">
	<div class="kt-header-mobile__logo">
		<a routerLink="/">
			<img alt="logo" [attr.src]="basePath.pathRef+headerLogo" />
		</a>
	</div>


	<div class="kt-header-mobile__toolbar kt-header__topbar2">
	<div class="">
	</div>
		<!--begin: Notifications -->
		<!-- <app-waiting-task  [bgImage]="basePath.pathRef+'assets/media/bg/notification_bg.jpg'" [pulse]="true" [skin]="'lilac'" [icon]="basePath.pathRef+'assets/media/icons/svg/Code/Compiling.svg'" [useSVG]="true"></app-waiting-task>
		 -->
		<!--end: Notifications -->

		<!--begin: Notifications -->
		<app-processing-task [bgImage]="basePath.pathRef+'assets/media/bg/notification_bg.jpg'" [pulse]="true"
			[skin]="'lilac'" [icon]="basePath.pathRef+'assets/media/icons/svg/Code/Compiling.svg'" [useSVG]="true">
		</app-processing-task>
		<!--end: Notifications -->

		<!--begin: Notifications -->
		<app-finished-task [bgImage]="basePath.pathRef+'assets/media/bg/notification_bg.jpg'" [pulse]="true"
			[skin]="'lilac'" [icon]="basePath.pathRef+'assets/media/icons/svg/Code/Compiling.svg'" [useSVG]="true">
		</app-finished-task> 
		<!--end: Notifications -->

		<button [hidden]="!asideDisplay" class="kt-header-mobile__toggler kt-header-mobile__toggler--left"
			id="kt_aside_mobile_toggler"><span></span></button>
		<button class="kt-header-mobile__toggler" id="kt_header_mobile_toggler"><span></span></button>
		<button ktToggle [options]="toggleOptions" class="kt-header-mobile__topbar-toggler"
			id="kt_header_mobile_topbar_toggler"><i class="flaticon-more"></i></button>
	</div>


</div>
<!-- end:: Header Mobile -->